module.exports = __webpack_public_path__ + "static/img/new_program_05.82f83d93.jpg";